module.exports = __webpack_public_path__ + "static/media/IMG_20191128_145629.59d0fa70.jpg";